import store from "../../index";
import pinia from "@/store/pinia";
import { useAuthSessionStore } from "@/store/pinia/useAuthSessionStore";

const authStore = () => useAuthSessionStore(pinia);

const clearModuleCaches = () => {
  store.dispatch("absence_admin/clearCache");
  store.dispatch("absence_request/clearCache");
  store.dispatch("admin/clearCache");
  store.dispatch("quotas/clearCache");
  store.dispatch("specialday/clearCache");
  store.dispatch("work_schedule/clearCache");
  store.dispatch("broadcast_template/clearCache");
  store.dispatch("seating_arrangement/clearCache");
  store.dispatch("census_seating/clearCache");
  store.dispatch("census_team/clearCache");
  store.dispatch("census_user/clearCache");
  store.dispatch("user_permission/clearCache");
  store.dispatch("dashboard/clearCache");
  store.dispatch("employee/clearCache");
  store.dispatch("enterprise_clients/clearCache");
  store.dispatch("enterprise_core/clearCache");
  store.dispatch("enterprise_journal/clearCache");
  store.dispatch("overtime_policies/clearCache");
  store.dispatch("overtime_requests/clearCache");
  store.dispatch("enterprise_overview/clearCache");
  store.dispatch("project_dimensions/clearCache");
  store.dispatch("enterprise_projects/clearCache");
  store.dispatch("enterprise_tiers/clearCache");
  store.dispatch("risk_management/clearCache");
  store.dispatch("project/clearCache");
  store.dispatch("tenant/clearCache");
  store.dispatch("uiConfigStore/clearCache");
  store.dispatch("worklog/clearCache");
  store.dispatch("vacation_worklog/clearCache");
  store.dispatch("unknownIssues/clearCache");
  store.dispatch("adminConfig/clearCache");
  store.dispatch("forecast_chance_category/clearCache");
  store.dispatch("forecast_scenario/clearCache");
  store.dispatch("forecast_fact/clearCache");
  store.dispatch("forecast_plan/clearCache");
  store.dispatch("forecast_segment/clearCache");
  store.dispatch("forecast_year/clearCache");
  store.dispatch("project_risk/clearCache");
  store.dispatch("project_risk/clearCache");
  store.dispatch("role/clearCache");
  store.dispatch("association/clearCache");
  store.dispatch("outsource_projects/clearCache");
  store.dispatch("support_projects/clearCache");
  store.dispatch("env/clearCache");
};

const actions = {
  bootstrap: async () => authStore().bootstrap(),
  refreshJwt: async () => authStore().refreshJwt(),
  login: async (_ctx, loginRequest) => authStore().login(loginRequest),
  setJwt: async (_ctx, authContext) => authStore().setJwt(authContext),
  resetPassword: async (_ctx, requestData) =>
    authStore().resetPassword(requestData),
  confirmPasswordRecovery: async (_ctx, requestData) =>
    authStore().confirmPasswordRecovery(requestData),
  second: async (_ctx, solution) => authStore().second(solution),
  activate: async (_ctx, activation) => authStore().activate(activation),
  logout: async (_ctx, ids) => {
    await authStore().logout(ids);
    clearModuleCaches();
  },
  logMeOut: async () => {
    await authStore().logMeOut();
    clearModuleCaches();
  },
  logMeOutEverywhere: async () => {
    await authStore().logMeOutEverywhere();
    clearModuleCaches();
  },
  boot: () => {
    authStore().boot(true);
    clearModuleCaches();
  },
  fetchSessionData: async (_ctx, userId = undefined) =>
    authStore().fetchSessionData(userId),
  fetchAllSessionData: async () => authStore().fetchAllSessionData(),
  updateSelectedForecastYear: (_ctx, year) =>
    authStore().updateSelectedForecastYear(year),
};

const mutations = {};

const getters = {
  axios: () => undefined,
  isLoggedIn: () => authStore().isLoggedIn,
  isReady: () => authStore().isReady,
  jwt: () => "",
  userId: () => authStore().userId,
  isRoot: () => authStore().isRoot,
  displayName: () => authStore().displayName,
  loggingRequired: () => authStore().loggingRequired,
  workScheduleMode: () => authStore().workScheduleMode,
  refreshToken: () => undefined,
  avatar: () => authStore().avatar,
  occupation: () => authStore().occupation,
  partnerId: () => authStore().partnerId,
  selectedForecastYear: () => authStore().selectedForecastYearResolved,
  authorities: () => authStore().authorities,
  hasAuthority: () => (auth) => authStore().hasAuthority(auth),
  hasAnyAuthority:
    () =>
    (...auths) =>
      authStore().hasAnyAuthority(...auths),
  jwtHeader: () => ({}),
  reloginRequired: () => authStore().reloginRequired,
  sessionData: () => (user) => authStore().sessionData[user],
  isCurrentSession: () => authStore().isCurrentSession,
  tenantId: () => authStore().tenantId,
  bootstrapped: () => authStore().bootstrapped,
};

export default {
  namespaced: true,
  state: () => ({}),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
